import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useI18n } from '@/i18n/i18n';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="app-shell items-center justify-center p-6">
      <div className="empty-state max-w-md bg-surface p-8">
        <h1 className="font-display text-4xl">404</h1>
        <p className="mt-2 text-muted">{t('notFound.text')}</p>
        <Link to="/" className="mt-4 inline-block">
          <Button variant="secondary">{t('common.backHome')}</Button>
        </Link>
      </div>
    </div>
  );
}
